import React from 'react';
import {Link} from 'react-router-dom';
import {Flex} from '@components';
import {Form, DatePicker, Input, InputNumber, Button, Select, Table, Icon, TimePicker} from 'antd';
import NHUpload from '../../../components/common/NHUpload';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import NHFetch from "@utils/NHFetch";
import {message} from "antd/lib/index";
import moment from 'moment';
import NHSelect from "@components/common/NHSelect";
import {createUuid, getLoginUser} from '@utils/NHCore';
import NextButton from '@pages/SelfHelp/common/nextIndex'
// import 'moment/src/locale/zh-cn';
import createHistory from 'history/createHashHistory';
import CommonTip from "../common";
import {mkbz} from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
import './index.css';

const history = createHistory();
const format = 'HH:mm';


const basicUrl = "/zzbd";
const commonUrl = '/zzbdCommon';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
};

@Form.create()
export default class ReportTsxy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD004_16',
            hjmc: '',
            editable: true,
            update: false,
            initPOvalue: {
                nd: '',
                xsid: '',
                sfasbd: '',
                basbdyy: '',
                jtgj: '',
                ddz: '',
                dxsj: '',
                bc: '',
                ptrs: 0,
                fj: ''
            },
            value: null,
            lxjtgjmcList: {},
            lxjtgjmc: '',
            ddz: {},
            options: [],
            dqddz: '',
            nextUrl: '',//左侧菜单加载完后传进来
            search: '',
            operable: true,//是否显示环节
            nonOperationalData: {},//不可操作的数据
            isHide: true,
            lxjtgjbc: '来校交通工具',
            lxrqbc: '来校日期',
            bccccph: '班次/车次/车牌号',
            isShow: false,//来校日期是否显示
            configDate: null,  // 后端配置的规定报到日期，用于限制日期选择器范围
            currentSfasbd: '', // 当前"是否按时报到"的选中值，供 disabledStartDate 实时读取
            shlczt: null,      // 审核流程状态（天狮学院报到情况审核）
            rejectReason: null,// 驳回意见 { shyj, shsj, szjdmc }
        };
    }


    componentWillMount() {
        this.getDmkMc("YXWZ_LXJTGJ");

    }

    //渲染前获取信息
    componentDidMount() {
        this.queryQztjAndYlhj();
        this.getLxjtgjmc();
        this.getLxrqmc();
        this.getDdz();
        this.getQkpo();
        this.getBccccph();
        this.getConfigDate(); // 获取后端配置的规定报到日期
        this.getBasbdShStatus(); // 获取审核状态和驳回意见
    }

    // 查询不按时报到的审核状态及驳回意见（天狮学院）
    getBasbdShStatus = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) return;
        NHFetch("/tsxy/zzbd/getBasbdShStatus", "GET", { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        shlczt: res.data.shlczt,
                        rejectReason: res.data.shyj ? {
                            shyj: res.data.shyj,
                            shsj: res.data.shsj,
                            szjdmc: res.data.szjdmc,
                        } : null,
                    });
                }
            });
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: {nologin: true},
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', {xsid: xsid, zzbdhjid: zzbdhjid})
          .then(res => {
              if (res && res.data) {
                  let kfsj = res.data['kfsj'];
                  let ylhj = res.data['ylhj'];
                  let qzhj = res.data['qzhj'];
                  let nohj = res.data['nohj'];
                  this.setState({nonOperationalData: res.data});
                  if (kfsj && kfsj['YXSJ'] != '1') {
                      this.setState({operable: false});
                  }

                  if (ylhj && ylhj.length > 0) {
                      this.setState({operable: false});
                  }

                  if (qzhj && qzhj.length > 0) {
                      this.setState({operable: false});
                  }

                  if (nohj) {
                    this.setState({ operable: false });
                }
              }
          });
    }

    getLxjtgjmc = () => {
        NHFetch('/zzbdCommon/getCssz', "GET", {csbz: 'YXXT_ZZBD_BDQK_ZDBC_LXJTGJ'})
          .then(res => {
              if (res) {
                  if (res && res.code === 200) {
                      this.setState({lxjtgjbc: res.data});
                  }
              }
          });
    }

    getLxrqmc = () => {
        NHFetch('/zzbdCommon/getCssz', "GET", {csbz: 'YXXT_ZZBD_BDQK_ZDBC_LXRQ'})
          .then(res => {
              if (res) {
                  if (res && res.code === 200) {
                      this.setState({lxrqbc: res.data});
                  }
              }
          });
    }


    getBccccph = () => {
        NHFetch('/zzbdCommon/getCssz', "GET", {csbz: 'YXXT_ZZBD_BDQK_ZDBC_BCCCCPH'})
          .then(res => {
              if (res) {
                  if (res && res.code === 200) {
                      this.setState({bccccph: res.data});
                  }
              }
          });
    }

    /**
     * 获取后端配置的"规定报到日期"，用于限制日期选择器范围。
     * 参数库配置标识：TSXY_LXBD_DXSJ（天狮学院-来校报到-到校时间）
     */
    getConfigDate = () => {
        NHFetch('/zzbdCommon/getCssz', 'GET', { csbz: 'TSXY_LXBD_DXSJ' })
          .then(res => {
              if (res && res.code === 200 && res.data) {
                  const date = moment(res.data, 'YYYY-MM-DD');
                  if (date.isValid()) {
                      this.setState({ configDate: date });
                  }
              }
          });
    };

    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    setMenuList = (menuList) => {
        // 固定当前环节为 GD004_16，hjmc 由菜单数据匹配设置
        let currentIndex = -1;
        menuList.forEach((elem, index) => {
            if (elem.HJDM === 'GD004_16') {
                currentIndex = index;
                this.setState({ hjmc: elem.HJMC });
            }
        });

        // 计算下一环节路由（复用原有逻辑）
        let nextCount = currentIndex + 1;
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            } else if(hjdm.indexOf('DCWJ')==0){
                let wjUrl  = "/customizeExamination";
                this.setState({
                    nextUrl:wjUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }

    getQkpo() {
        const xsid = getLoginUser().userId;
        let lxjtgjmc = '';
        NHFetch("/tsxy/zzbd/getQkpoByXsidAndNd", "GET", {xsid: xsid})
          .then(res => {
              if (res) {
                  if (res.data) {
                      lxjtgjmc = res.data.jtgjmc;
                      // 第一次 setState：回填表单数据及状态
                      this.setState({
                          initPOvalue: res.data,
                          editable: false,
                          lxjtgjmc: lxjtgjmc,
                          isHide: String(res.data.sfasbd) !== '1',
                          currentSfasbd: String(res.data.sfasbd || '')  // 同步 sfasbd，统一转字符串
                      });
                      // 保持原有执行顺序：先获取 ddz，再触发 onChange 级联更新
                      let dqddz = this.state.initPOvalue.ddz;
                      this.onChange(this.state.initPOvalue.jtgj);
                      this.setState({dqddz: dqddz});
                  }
              }
          });
    }


    handleSubmit = e => {
        e.preventDefault();
        // 审核中或已通过时禁止提交
        if (this.state.shlczt === '0' || this.state.shlczt === '1') {
            message.warning('当前审核中或已通过，不可修改报到情况');
            return;
        }
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }
            if (values['sfasbd'] == '0') {
                if (values['basbdyy'] == null || typeof (values['basbdyy']) == "undefined" || values['basbdyy'].trim().length === 0) {
                    message.error('不按时到达请填写原因。');
                    return
                }
            }

            let sUrl = '/saveBdqkData';
            if (this.state.update) {
                sUrl = '/updateBdqkData';
            }
            //修改 可编辑状态，并可以update数据
            if (!this.state.editable) {
                this.setState({update: true, editable: true});
                return
            }
            const {dxsj} = values;
            let dxsjVal = moment(dxsj).format("YYYY-MM-DD HH:mm");
            values.dxsj = dxsjVal;
            const xsid = getLoginUser().userId;
            const zzbdhjid = this.getUrlParams("pkid");
            let params = {xsid: xsid, zzbdhjid: zzbdhjid, formData: values};


            //请求保存或修改数据
            NHFetch("/tsxy/zzbd" + sUrl, 'POST', params)
              .then(res => {
                  if (res) {
                      if (res.data == '1') {
                          message.success('信息保存成功！');
                          this.reloadMenu();
                          this.getQkpo();
                          this.getBasbdShStatus(); // 刷新审核状态（驳回后重新提交时清除驳回意见）
                      } else {
                          message.error('信息保存失败，请重试！');
                      }
                  }
              })
        });
    };

    //获取url中传递的参数
    getUrlParams = (param) => {
        return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    };


    //获取下拉列表value对应的名称
    getDmkMc = (dmbz) => {
        NHFetch(basicUrl + "/getDmkMc", "GET", {dmbz: dmbz})
          .then(res => {
              if (res) {
                  if (res.data) {
                      if (dmbz === "YXWZ_LXJTGJ") {
                          this.setState({lxjtgjmcList: res.data});
                      }
                  }
              }
          });
    }
    //获取到达站下拉列表的名称
    getDdz = () => {
        NHFetch(basicUrl + "/getDdz", "GET")
          .then(res => {
              if (res) {
                  if (res.data) {
                      this.setState({ddz: res.data});
                  }
              }
          });
    }

    //到达站级联
    DdzSeleOption = (value) => {

        let dqddz = '';
        let coptions = '';
        if (this.state.ddz.length > 0) {
            coptions = this.state.ddz.map((item, key) => {
                if (value === item.ZTLX) {
                    dqddz = item.ZTMC;
                    return <Option key={item.ZTMC}>{item.ZTMC}</Option>
                } else {
                    return null
                }
            });

        }
        this.props.form.setFieldsValue({ddz: dqddz});
        this.setState({options: coptions, dqddz: dqddz});

    }


    //下拉框发生变化检测
    onChange = (value) => {
        this.DdzSeleOption(value);
    }

    /**
     * 是否按时报到选项变化回调。
     * 同步更新 sfasbd 到 state，使 disabledStartDate 能实时感知并限制日期范围。
     * 使用 String() 转换兼容后端可能返回的数字类型（1/'1'、0/'0'）。
     */
    onSfasbdChange = (value) => {
        const sfasbd = String(value);
        this.setState({
            isHide: sfasbd !== '1',
            isShow: true,
            currentSfasbd: sfasbd
        });
    }

    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }

    //陪同人数不符合时提示
    numberChange = (value) => {
        if (value > 10 || value < 0) {
            message.warning('陪同人数请填写0-10之内的整数！');
        }
    }

    /**
     * 禁用日期选择器中不可选的日期。
     * 规则：
     * 1. 当选择"按时报到"(sfasbd='1')且后端配置了规定日期时，
     *    仅允许选择规定日期前后两天（含当天，共5天）。
     * 2. 当选择"否"(sfasbd='0')且后端配置了规定日期时，
     *    禁用上述5天，其他所有日期均可选。
     * 3. 其他情况：全部放开，不做限制。
     */
    disabledStartDate = startValue => {
        if (!startValue) {
            return false;
        }
        const { currentSfasbd, configDate } = this.state;

        if (!configDate) {
            return false;
        }

        const minDate = configDate.clone().subtract(2, 'days').startOf('day');
        const maxDate = configDate.clone().add(2, 'days').endOf('day');

        // 选择"是"时，仅允许选这5天
        if (currentSfasbd === '1') {
            return startValue < minDate || startValue > maxDate;
        }

        // 选择"否"时，禁用这5天，其他均可选
        if (currentSfasbd === '0') {
            return startValue >= minDate && startValue <= maxDate;
        }

        return false;
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {editable, initPOvalue, lxjtgjmc, options, dqddz, isHide, lxjtgjbc, lxrqbc, isShow, bccccph, shlczt, rejectReason} = this.state;
        // 审核中或已通过时不可编辑
        const canEdit = editable && shlczt !== '0' && shlczt !== '1';
        return (
          <div>{this.state.operable ?
            <Flex className="w1180 mt-20" align="start">
                <SiderMenu
                  ref={"siderMenu"}
                  setMenuList={this.setMenuList}
                  title="自助报到"
                  /* active={3}*/
                  mkbz={this.state.mkbz}
                  menuType='自助报到'
                />
                <Flex.Item className="page_con_r" styleName="">
                    <Breadcrumb
                      noLine
                      list={[
                          {name: '首页', url: '/index'},
                          {name: '自助报到', url: '/register'},
                          {name: this.state.hjmc}
                      ]}
                    />
                    <div className="box">
                        <Hint/>
                        <TitleTop title={this.state.hjmc} extra={false}/>
                        <Form onSubmit={this.handleSubmit}>
                            <div className="p-sw">
                                <Flex align="start" wrap="wrap">

                                    <div className="form_item">
                                        <FormItem
                                          {...formItemLayout}
                                          label="是否按时报到"
                                        >
                                            {getFieldDecorator('sfasbd', {
                                                initialValue: initPOvalue.sfasbd, placeholder: '请选择',
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                          '请选择是否按时报到'
                                                    }
                                                ]
                                            })(
                                              canEdit ?
                                                <Select placeholder="请选择" onChange={this.onSfasbdChange}>
                                                    <Option value="1">
                                                        是
                                                    </Option>
                                                    <Option value="0">
                                                        否
                                                    </Option>
                                                </Select> : <span>{initPOvalue.sfasbd == 1 ? '是' : '否'}</span>
                                            )}
                                        </FormItem>
                                    </div>
                                    {isHide &&
                                    <div className="form_item">
                                        <FormItem
                                          {...formItemLayout}
                                          label="不按时报到原因"
                                        >
                                            {getFieldDecorator('basbdyy', {initialValue: initPOvalue.basbdyy,
                                             rules: [
                                                {
                                                    required: true,
                                                    message:
                                                      '请填写原因'
                                                }
                                            ]
                                        })(
                                              canEdit ? <Input placeholder="请填写原因"/> :
                                                <span>{initPOvalue.basbdyy}</span>
                                            )}
                                        </FormItem>
                                    </div>
                                    }
                                    {isHide &&
                                    <div className="form_item">
                                        <FormItem
                                          {...formItemLayout}
                                          label="请假材料"
                                        >
                                            {getFieldDecorator('fj', {
                                                initialValue: initPOvalue.fj
                                            })(
                                              canEdit ?
                                                <NHUpload
                                                    serviceMark={"ly-sm-yxwz-svc"}
                                                    moduleName={"请假材料"}
                                                    value={initPOvalue.fj}
                                                    isEdit={editable}
                                                    defaultEffective={true}
                                                    listType="text"
                                                    fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.pdf', '.PDF']}
                                                    onChange={(value) => { this.setState({ fj: value }) }}
                                                /> :
                                                <NHUpload
                                                    serviceMark={"ly-sm-yxwz-svc"}
                                                    moduleName={"请假材料"}
                                                    value={initPOvalue.fj}
                                                    isEdit={false}
                                                    defaultEffective={true}
                                                    listType="text"
                                                />
                                            )}
                                        </FormItem>
                                    </div>
                                    }

                                    {!isHide &&
                                    <div className="form_item">
                                        <FormItem
                                          {...formItemLayout}
                                          label={lxjtgjbc ? lxjtgjbc : '来校交通工具'}
                                        >
                                            {getFieldDecorator('jtgj', {
                                                initialValue: initPOvalue.jtgj,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                          '请选择交通工具'
                                                    }
                                                ]
                                            })(
                                              canEdit ?

                                                <NHSelect sign={"zhxg_yxwz_jtfs"} onChange={(v) => {
                                                    this.onChange(v);
                                                }}/>

                                                : <span>{lxjtgjmc}</span>
                                            )}
                                        </FormItem>
                                    </div>
                                    }
                                    {!isHide &&
                                    <div className="form_item">
                                        <FormItem
                                          {...formItemLayout}
                                          label="到达站"
                                        >
                                            {getFieldDecorator('ddz', {
                                                initialValue: dqddz,
                                                rules: [
                                                    {
                                                        message:
                                                          '请选择到达站'
                                                    }
                                                ]
                                            })(
                                              canEdit ?

                                                <Select>
                                                    {options}
                                                </Select>

                                                : <span>{dqddz}</span>
                                            )}
                                        </FormItem>
                                    </div>
                                    }
                                    {(isShow || initPOvalue.sfasbd == '0' || initPOvalue.sfasbd == '1') &&
                                    <div className="form_item">
                                        <FormItem
                                          {...formItemLayout}
                                          label={isHide ? '预计来校日期' : (lxrqbc ? lxrqbc : '预计来校日期')}
                                        >
                                            {getFieldDecorator('dxsj', {
                                                initialValue: initPOvalue.dxsj == '' ? null : moment(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm'),
                                                rules: [
                                                    {
                                                        required: !isHide,
                                                        message:
                                                          '请选择日期'
                                                    }
                                                ]
                                            })(
                                              canEdit ?
                                                <DatePicker
                                                  style={{'width': '100%'}}
                                                  showTime
                                                  format="YYYY-MM-DD HH:mm"
                                                  disabledDate={this.disabledStartDate}
                                                  // defaultValue={initPOvalue.dxsj==''?null:moment(initPOvalue.dxsj, 'YYYY-MM-DD HH:mm')} //如果时间发生错误，请删除此句defaultValue

                                                />
                                                : <span>{initPOvalue.dxsj === 'Invalid date' ? '' : initPOvalue.dxsj}</span>
                                            )}
                                        </FormItem>
                                    </div>
                                    }

                                    {!isHide &&
                                    <div className="form_item">
                                        <FormItem
                                          {...formItemLayout}
                                        //   label="班次/车次"
                                        label = {isHide ? '班次/车次' : (bccccph ? bccccph : '班次/车次')}
                                        >
                                            {getFieldDecorator('bc', {initialValue: initPOvalue.bc})(
                                              canEdit ?
                                                <Input

                                                /> : <span>{initPOvalue.bc}</span>
                                            )}
                                        </FormItem>
                                    </div>
                                    }
                                    {!isHide &&
                                    <div className="form_item">
                                        <FormItem
                                          {...formItemLayout}
                                          label="陪同人数"
                                        >
                                            {getFieldDecorator('ptrs', {initialValue: initPOvalue.ptrs})(
                                              canEdit ?
                                                <InputNumber
                                                  precision={0}
                                                  min={0}
                                                  max={10}
                                                  onChange={this.numberChange}
                                                /> : <span>{initPOvalue.ptrs}</span>
                                            )}&nbsp;&nbsp;<span>  (人) </span>
                                        </FormItem>
                                    </div>
                                    }
                                </Flex>
                                {/* 驳回意见展示（审核不通过时在表单底部显示） */}
                                {shlczt === '-2' && rejectReason && (
                                    <div styleName="reject_notice">
                                        <div styleName="reject_notice_title">审核不通过</div>
                                        <div>审核节点：{rejectReason.szjdmc}</div>
                                        <div>审核时间：{rejectReason.shsj}</div>
                                        <div>审核意见：{rejectReason.shyj}</div>
                                    </div>
                                )}
                                <div className="text-center mt-50">
                                    {/* 审核中或已通过时不显示修改/保存按钮 */}
                                    {shlczt !== '0' && shlczt !== '1' && (
                                        <Button
                                          type="primary"
                                          htmlType="submit"
                                        >
                                            {canEdit ? '保存' : '修改'}
                                        </Button>
                                    )}
                                    <NextButton nextUrl={this.state.nextUrl} search={this.state.search}/>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Flex.Item>
            </Flex>
            :
            <CommonTip hjmc={"报到情况填写"} key={'GD004_16'} mkbz='GD004_16' nonOperationalData={this.state.nonOperationalData}/>}
          </div>
        );
    }
}
